import AuthHelpers from "./AuthHelpers";

class WorkerHelpers {
  isSupportedBrowser = () => {
    return (
      "Notification" in window &&
      "serviceWorker" in navigator &&
      "PushManager" in window
    );
  };

  initPush() {
    if (!navigator.serviceWorker.ready) {
      return;
    }
    new Promise(function (resolve, reject) {
      const permissionResult = Notification.requestPermission(
        function (result) {
          resolve(result);
        },
      );
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          // console.log("Notification permission granted.");
        } else {
          // console.log("You need to allow notification in your browser");
        }
      });
      if (permissionResult) {
        permissionResult.then(resolve, reject);
      }
    }).then((permissionResult) => {
      if (permissionResult !== "granted") {
        // console.log("We weren't granted permission.");
        throw new Error("We weren't granted permission.");
      }
      this.subscribeUser();
    });
  }

  subscribeUser() {
    navigator.serviceWorker.ready
      .then((registration) => {
        const subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(
            "BLdnKhFc7fthfF_1fe3JkKbarX5X0o-V-INDAm0Ja4E3TGSN8tLAtn9BEazbEQPwC8gxfacfA8cXhwnTX99YQLw",
          ),
        };

        return registration.pushManager.subscribe(subscribeOptions);
      })
      .then((pushSubscription) => {
        // console.log("Received PushSubscription: ", JSON.stringify(pushSubscription));
        this.storePushSubscription(pushSubscription);
      });
  }

  urlBase64ToUint8Array(base64String) {
    var padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  storePushSubscription(pushSubscription) {
    fetch(`${import.meta.env.VITE_API_BASE_URL}/api/subscribe`, {
      method: "POST",
      body: JSON.stringify(pushSubscription),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${AuthHelpers.auth_token()}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((_res) => {
        // console.log(res);
      })
      .catch((_err) => {
        // console.log(err);
      });
  }
}

export default new WorkerHelpers();
